
















import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({
  name: 'sync-console-tabs-nav',
})
export default class SyncConsoleTabsNav extends Vue {
  @Prop({ required: true }) readonly value!: string;

  tabs = [
    {
      name: 'pos-session',
      label: 'accounting_integrations.sale_days_sync.tabs.sessions',
    },
    // TODO uncomment when tabs are ready
    // {
    //   name: 'invoices',
    //   label: 'accounting_integrations.sale_days_sync.tabs.invoices',
    // },
    // {
    //   name: 'credit-notes',
    //   label: 'accounting_integrations.sale_days_sync.tabs.credit_notes',
    // },
    {
      name: 'online',
      label: 'accounting_integrations.sale_days_sync.tabs.online',
    },
  ];
}
